//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import publicRoute from "./component/publicRoute";
import ToDo from "./component/ToDo.vue";
import redBorderDialog from "./component/redBorderDialog.vue";
import collectionDialog from "./component/collectionDialog.vue";
export default {
  extends: publicRoute,
  name: "applicationLoad",
  components: {
    ToDo,
    redBorderDialog,
    collectionDialog
  },
  data() {
    return {
      url: "api/api/findApplicationDetail",
      record: {},
      interviewList: [],
      showNodata: false,
      rowArray: [],
      selectTabs: 1,
      fileList: [],
      isOffer: false,
      isDelete: false,

      toDoIsUpload: false,
      toDoIsOffer: false,
      toDoIsEPIC: false,
      toDoItem: [],
      redBorderDialogBool: false,
      collectionDialog: false,
    };
  },
  methods: {
    changTabs(index) {
      this.selectTabs = index;
    },
    async updateInterview(item, value) {
      let params = {};
      let url = "api/api/updateInterview";
      let reason = item.reason;
      let str = "";
      if ("1" == value) {
        params.status = "accept";
        str = "Are you sure to accept the schedule?";
      } else {
        params.status = "reject";
        if (!this.isNotNullOrEmpty(reason)) {
          this.$msgDailog.showMsgBox({
            title: "Please fill out the reason",
          });
          return;
        }
        params.reason = reason;
        str = "Are you sure to reassess the schedule?";
      }
      params.uuid = item.uuid;
      let flag = await this.tipCustomConfirmNew("default", str, "").then(
        (res) => {
          return res;
        }
      );
      if (flag) {
        this.axios.post(url, params).then(({ data }) => {
          if (data.code == "1") {
            this.doLoadRecord();
          }
        });
      }
    },
    async doLoadRecord() {
      this.rowArray = [];
      let uuid = this.$route.query.uuid;
      let oQuery = {
        uuid: uuid,
      };
      await this.axios.post(this.url, oQuery).then(({ data }) => {
        if (data.code == "1") {
          this.record = data.data.record;
          this.interviewList = this.record.interview;
          this.showNoData = true;
          this.fileList = this.record.fileList;
          if (this.record.isDelete) {
            this.isDelete = this.record.isDelete;
          }
        }
      });
    },
    async changeShowReason(value, uuid) {
      if ("1" == value) {
        if (this.rowArray.length == 0 || this.rowArray.indexOf(uuid) == -1) {
          this.rowArray.push(uuid);
        }
      } else {
        if (this.rowArray.indexOf(uuid) > -1) {
          let k = this.rowArray.indexOf(uuid);
          this.rowArray.splice(k, 1);
        }
      }
    },
    isShow(uuid) {
      if (this.rowArray.indexOf(uuid) > -1) {
        return true;
      }
      return false;
    },
    async deleteApplication() {
      let flag = await this.tipCustomConfirmNew(
        "default",
        "Are you sure to revoke this application?",
        ""
      ).then((res) => {
        return res;
      });
      if (flag) {
        let url = "api/api/deleteApplication";
        let oQuery = {
          uuid: this.record.uuid,
        };
        this.axios.post(url, oQuery).then(({ data }) => {
          if (data.code == "1") {
            // 跳转回主页面
            this.goBack();
          }
        });
      }
    },
    async download(link) {
      let url = "api/api/portalFile/download";
      let params = {
        fileid: link.fileId,
        filename: link.fileName,
        url: link.url,
        uuid: link.fileId,
      };
      this.axios
        .posttype(url, { record: params }, "arraybuffer")
        .then((res) => {
          let blob = new Blob([res.data]);
          let url = window.URL.createObjectURL(blob); //表示一个指定的file对象或Blob对象
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = link.fileName; //命名下载名称
          a.click(); //点击触发下载
          window.URL.revokeObjectURL(url); //下载完成进行释放
          document.body.removeChild(a);
        })
        .catch((error) => console.log(error));
    },

    async viewOffer() {
      let oQuery = {};
      let routerpath = "/portal/offerprocess";
      oQuery["applicationUuid"] = this.$route.query.uuid;
      this.openWin(routerpath, oQuery);
    },

    async findOfferProcess() {
      location.reload();
    },

    async getOfferProcess() {
      let params = {
        applicationNoUuid: this.$route.query.uuid,
      };
      let url = "api/api/findOfferProcess";
      this.axios.post(url, params).then(({ data }) => {
        if (data.code == "1") {
          let todoList = data.data.record;
          if (todoList && todoList.length > 0) {
            let currentFlow = todoList[0].currentFlow;
            if (currentFlow == 'Payslips Upload') {
              this.toDoIsUpload = true;
            } else if (currentFlow == 'Offer Acceptance') {
              this.toDoIsOffer = true;
            } else if (currentFlow == 'Complete EPIC (Employee Personal Information Collection) Form') {
              this.toDoIsEPIC = true;
            }
            this.toDoItem = todoList[0];
          }
        }
      });
    },

    async clickTodo() {
      let item = this.toDoItem;
      if (item.currentFlow == 'Payslips Upload') {
        this.openRedBorderDialog('payslipsUpload', item);
      } else if (item.currentFlow == 'Offer Acceptance') {
        this.openRedBorderDialog('offerAcceptance', item)
      } else {
        this.openCollectionDialog(item);
      }
    },

    openRedBorderDialog(type, item) {
      this.redBorderDialogBool = true;
      this.$nextTick(() => {
        this.$refs.RedBorderDialog.init(type, item);
      });
    },
    openCollectionDialog(item) {
      this.collectionDialog = true;
      this.$nextTick(() => {
        this.$refs.collectionDialog.init(item);
      });
    },
  },
  created() {
    this.doLoadRecord();
    this.getOfferProcess();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/applicationLoad.vue